module.exports = {
    name:      "moneygame",
    buildDate: "Mon Apr 01 2019 14:11:54 GMT+0000 (UTC)",
    version:   "1.0.0",
    build:     "28.2303 debug"
};



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 9
// module chunks = 0